export default __webpack_public_path__ + "static/media/790651399985299456.e1de7845.png";